function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import powerScale from './power';
export default function squareRootScale(scaleConfig) {
  var scale = powerScale(_extends({}, scaleConfig, {
    exponent: 0.5
  })); // @ts-ignore

  scale.type = 'squareRoot';
  return scale;
}